"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeStore = void 0;
var locale_1 = require("./locale");
Object.defineProperty(exports, "localeStore", { enumerable: true, get: function () { return locale_1.localeStore; } });
//# sourceMappingURL=index.js.map